import { useEffect } from "react";
import { useForm } from "../useForm";

import { Dialog } from "@headlessui/react";
import { XMarkIcon } from "@heroicons/react/24/outline";

import Input from "../../controls/Input";

const initialFValues = {
  name: "",
  description: "",
  quickbooks_id: "",
  sku: "",
  walmart_stock_number: "",
  walmart_item_number: "",
};

export default function SunProductsForm(props) {
  const { index, sunProduct, setOpen, actionCall, isEdit } = props;

  const { values, setValues, handleInputChange } = useForm(
    initialFValues,
    false
  );

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = {
      name: values.name,
      description: values.description || null,
      quickbooks_id: values.quickbooks_id || null,
      sku: values.sku ?? "",
      walmart_stock_number: values.walmart_stock_number ?? "",
      walmart_item_number: values.walmart_item_number ?? "",
    };
    if (isEdit) {
      actionCall(sunProduct, payload, index);
    } else {
      actionCall(payload);
    }
  };

  useEffect(() => {
    if (isEdit && sunProduct) {
      setValues({
        name: sunProduct.name ?? "",
        description: sunProduct.description ?? "",
        quickbooks_id: sunProduct.quickbooks_id ?? "",
        sku: sunProduct.sku ?? "",
        walmart_stock_number: sunProduct.walmart_stock_number ?? "",
        walmart_item_number: sunProduct.walmart_item_number ?? "",
      });
    }
  }, [sunProduct, isEdit, setValues]);

  return (
    <div className="flex h-full flex-col divide-y divide-gray-200 bg-white shadow-xl">
      <div className="flex min-h-0 flex-1 flex-col overflow-y-scroll py-6">
        <div className="px-4 sm:px-6">
          <div className="flex items-start justify-between">
            <Dialog.Title className="text-base font-semibold leading-6 text-gray-900">
              {isEdit && sunProduct
                ? `Edit ${sunProduct.name}`
                : "Add new SUN product"}
            </Dialog.Title>
            <div className="ml-3 flex h-7 items-center">
              <button
                type="button"
                className="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-indigo-500"
                onClick={() => setOpen({ childComponent: null, open: false })}
              >
                <span className="sr-only">Close panel</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
          </div>
        </div>
        <div className="relative mt-6 flex-1 px-4 sm:px-6 space-y-3">
          <Input
            label="Name"
            name="name"
            onChange={handleInputChange}
            value={values.name}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            disabled={true}
          />
          <Input
            label="Description"
            name="description"
            onChange={handleInputChange}
            value={values.description}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            disabled={true}
          />
          <Input
            label="QuickBooks ID"
            name="quickbooks_id"
            onChange={handleInputChange}
            value={values.quickbooks_id}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
            disabled={true}
          />
          <Input
            label="SKU"
            name="sku"
            onChange={handleInputChange}
            value={values.sku}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
          <Input
            label="Walmart Stock Number"
            name="walmart_stock_number"
            onChange={handleInputChange}
            value={values.walmart_stock_number}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
          <Input
            label="Walmart Item Number"
            name="walmart_item_number"
            onChange={handleInputChange}
            value={values.walmart_item_number}
            labelOn={true}
            type="text"
            className="mt-1 block w-full border border-gray-300 rounded-md shadow-sm py-35-custom px-3 focus:outline-none focus:ring-sky-500 focus:border-sky-500 sm:text-sm"
          />
        </div>
      </div>
      <div className="flex flex-shrink-0 justify-end px-4 py-4">
        <button
          type="button"
          className="rounded-md bg-white px-3 py-2 text-sm font-semibold text-gray-900 shadow-sm ring-1 ring-inset ring-gray-300 hover:ring-gray-400"
          onClick={() => setOpen({ childComponent: null, open: false })}
        >
          Cancel
        </button>
        <button
          type="submit"
          className="ml-4 inline-flex justify-center rounded-md bg-main-purple px-3 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-600 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          onClick={handleSubmit}
        >
          {isEdit ? "Save" : "Create"}
        </button>
      </div>
    </div>
  );
}
